import { EyeIcon, EyeOutlinedIcon } from "@/shared/icons";
import type { FC } from "react";
import { AppButton } from "../../AppButton";
import styles from "../styles.module.scss";

interface Props {
  onClick: () => void;
  isVisible: boolean;
}

export const VisibilityControlButton: FC<Props> = ({ onClick, isVisible }) => {
  return (
    <AppButton
      icon={
        <>
          {isVisible ? (
            <EyeIcon width={24} height={24} className={styles.icon} />
          ) : (
            <EyeOutlinedIcon />
          )}
        </>
      }
      onClick={onClick}
      type="text"
    />
  );
};
